(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/day-time-limit/assets/javascripts/day-time-limit.js') >= 0) return;  svs.modules.push('/components/accountservices/day-time-limit/assets/javascripts/day-time-limit.js');
"use strict";

svs.accountservices = svs.accountservices || {};
svs.accountservices.day_time_limit = svs.accountservices.day_time_limit || {};
(function (svs) {
  const logger = svs.core.log.getLogger('components:day-time-limit');
  let soonMsgTimeoutID;
  let endMsgTimeoutID;
  let soonMsgTimeoutMs;
  let endMsgTimeoutMs;
  let soonMsgTimeoutStart;
  let endMsgTimeoutStart;
  let midnightResetTimeoutID;

  function get(callback) {
    logger.info('Getting day time limit');
    svs.core.jupiter.call({
      path: '/player/2/daytimelimit',
      method: 'GET'
    }, data => {
      svs.day_time_limit = svs.day_time_limit || {};
      svs.day_time_limit.data.dayTimeLimit = svs.day_time_limit.data.dayTimeLimit || {};
      svs.day_time_limit.data.dayTimeLimit = svs.accountservices.day_time_limit.setUpModel(data);
      init();
      if (callback && typeof callback === 'function') {
        callback(svs.day_time_limit.data.dayTimeLimit, null);
      }
    }, error => {
      logger.info('Error getting daytimelimit', error);
      if (callback && typeof callback === 'function') {
        callback(null, error);
      }
    });
  }

  function showDialog(dialogObject) {
    const dialogButtons = dialogObject.buttons.map(button => {
      let cb;
      if (button.callback) {
        cb = () => {
          button.callback.call();
          dialog.close();
        };
      }
      return {
        title: button.text,
        callback: cb
      };
    });
    const dialog = new svs.ui.dialog.Confirm({
      icon: 'time-limit',
      branding: svs.ui.dialog.branding.TUR,
      type: svs.ui.dialog.type.INFO,
      area: dialogObject.area ? dialogObject.area : svs.ui.dialog.area.POPUP,
      title: dialogObject.title,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: dialogObject.message
      }],
      actions: dialogButtons
    });
    svs.ui.dialog.api.close();
    svs.ui.dialog.api.add(dialog);
  }

  function showSoonEndMessage(timeForSoonMessageText, timeForSoonMessage) {
    svs.core.userSession.get('dayTimeLimit_SoonMessageSeen', (error, data) => {
      if (!data) {
        const dialogObject = {
          area: svs.ui.dialog.area.TOASTER,
          title: 'Tidsgräns snart uppnådd',
          message: "Om ".concat(timeForSoonMessageText ? timeForSoonMessageText : 'fem', " ").concat((timeForSoonMessage == undefined ? 5 : timeForSoonMessage) > 1 ? 'minuter' : 'minut', " uppn\xE5r du din dagliga tidsgr\xE4ns. N\xE4r du n\xE5tt din tidsgr\xE4ns kan du inte betala spel eller s\xE4tta in pengar."),
          buttons: [{
            text: 'Okej',
            callback() {
              clearTimeout(soonMsgTimeoutID);
              logger.info('Customer clicks OK in soon reach day time limit dialog.');
            }
          }]
        };
        svs.core.userSession.set('dayTimeLimit_SoonMessageSeen', true, () => {
          logger.info('Showing message for customer who soon will reach day time limit.');
          showDialog(dialogObject);
          get();
        });
      }
    });
  }

  function showEndMessage() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    svs.core.userSession.get('dayTimeLimit_EndMessageSeen', (error, data) => {
      if (!data) {
        const dialogObject = {
          title: 'Tidsgräns uppnådd',
          message: 'Du har uppnått din dagliga tidsgräns. När du har nått din tidsgräns kan du inte betala spel eller sätta in pengar.',
          buttons: [{
            text: 'Logga ut',
            callback() {
              clearTimeout(endMsgTimeoutID);
              logger.info('Customer logged out due to day time limit is reached.');
              svs.core.userSession.logout();
            }
          }, {
            text: 'Okej',
            callback() {
              clearTimeout(endMsgTimeoutID);
              logger.info('Customer stays logged in although day time limit is reached.');
              if (options && options.returnUrl) {
                svs.utils.url.navigate(svs.utils.url.makeInternal(options.returnUrl, svs.core.urlMapping.get('startPage')));
              }
            }
          }]
        };
        svs.core.userSession.set('dayTimeLimit_EndMessageSeen', true, () => {
          logger.info('Showing day time limit end message');
          showDialog(dialogObject);
          get();
        });
      } else if (options && options.returnUrl) {
        svs.utils.url.navigate(svs.utils.url.makeInternal(options.returnUrl, svs.core.urlMapping.get('startPage')));
      }
    });
  }

  function getMsToMidnight() {
    const now = new Date();
    const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    return midnight.getTime() - now.getTime();
  }

  function resetSeenFlags() {
    svs.core.userSession.set('dayTimeLimit_SoonMessageSeen', false, () => {
      logger.info('Cleared dayTimeLimit_SoonMessageSeen flag for new day');
    });
    svs.core.userSession.set('dayTimeLimit_EndMessageSeen', false, () => {
      logger.info('Cleared dayTimeLimit_EndMessageSeen flag for new day');
    });
  }

  function init() {
    clearTimeout(midnightResetTimeoutID);
    midnightResetTimeoutID = null;
    if (svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dayTimeLimit.dayTimeLimitIsSet) {
      logger.info('Customer with day time limit set');
      const dayTimeLimitData = svs.day_time_limit.data.dayTimeLimit;
      const msToMidnight = getMsToMidnight();
      let effectiveTimeToSoonEnd = dayTimeLimitData.timeToSoonEnd;
      let effectiveTimeToEnd = dayTimeLimitData.timeToEnd;

      let soonEndMsgText = dayTimeLimitData.timeForSoonMessageText;
      let soonEndMsgMinutes = dayTimeLimitData.timeForSoonMessage;
      if (effectiveTimeToEnd > 0 && effectiveTimeToEnd >= msToMidnight) {
        logger.info("Day time limit crosses midnight. Adjusting timeouts. msToMidnight=".concat(msToMidnight, ", timeToEndNextDay=").concat(dayTimeLimitData.timeToEndNextDay));
        effectiveTimeToEnd = msToMidnight + dayTimeLimitData.timeToEndNextDay;
        effectiveTimeToSoonEnd = msToMidnight + dayTimeLimitData.timeToSoonEndNextDay;

        soonEndMsgText = 'fem';
        soonEndMsgMinutes = 5;

        clearTimeout(midnightResetTimeoutID);
        midnightResetTimeoutID = window.setTimeout(() => {
          logger.info('Midnight reached. Clearing seen flags for new day.');
          resetSeenFlags();
        }, msToMidnight);
      }
      if (dayTimeLimitData && effectiveTimeToSoonEnd > 0) {
        soonMsgTimeoutMs = effectiveTimeToSoonEnd;
        soonMsgTimeoutStart = new Date().getTime();
        clearTimeout(soonMsgTimeoutID); 
        soonMsgTimeoutID = window.setTimeout(() => {
          svs.accountservices.day_time_limit.showSoonEndMessage(soonEndMsgText, soonEndMsgMinutes);
        }, effectiveTimeToSoonEnd);
      }
      if (dayTimeLimitData && effectiveTimeToEnd > 0) {
        endMsgTimeoutMs = effectiveTimeToEnd;
        endMsgTimeoutStart = new Date().getTime();
        clearTimeout(endMsgTimeoutID); 
        endMsgTimeoutID = window.setTimeout(() => {
          svs.accountservices.day_time_limit.showEndMessage();
        }, effectiveTimeToEnd);
      }
    }
  }

  function showErrorDialog(dialogObject) {
    const dialogButtons = dialogObject.buttons.map(button => {
      let cb;
      if (button.callback) {
        cb = () => {
          button.callback.call();
          dialog.close();
        };
      }
      return {
        title: button.text,
        callback: cb
      };
    });
    const dialog = new svs.ui.dialog.Confirm({
      type: svs.ui.dialog.type.ERROR,
      title: dialogObject.title,
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: dialogObject.message
      }],
      actions: dialogButtons
    });
    svs.ui.dialog.api.close();
    svs.ui.dialog.api.add(dialog);
  }

  function set(value) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    logger.info('Setting day time limit');
    svs.core.jupiter.call({
      path: "/player/2/daytimelimit",
      method: 'PUT',
      data: {
        dayTimeLimit: value
      }
    }, data => {
      svs.core.userSession.remove('session.dayTimeLimit', () => {
        svs.day_time_limit = svs.day_time_limit || {};
        svs.day_time_limit.data.dayTimeLimit = svs.day_time_limit.data.dayTimeLimit || {};
        svs.day_time_limit.data.dayTimeLimit = svs.accountservices.day_time_limit.setUpModel(data);
        init();
        if (callback && typeof callback === 'function') {
          callback(svs.day_time_limit.data.dayTimeLimit, null);
        }
      });
    }, error => {
      logger.warn('Error setting daytimelimit', error);
      if (callback && typeof callback === 'function') {
        callback(null, error);
      }
    });
  }

  function clear(callback) {
    logger.info('Clearing day time limit');
    svs.core.jupiter.call({
      path: "/player/2/cleardaytimelimit",
      method: 'POST'
    }, data => {
      svs.day_time_limit = svs.day_time_limit || {};
      svs.day_time_limit.data.dayTimeLimit = svs.day_time_limit.data.dayTimeLimit || {};
      svs.day_time_limit.data.dayTimeLimit = svs.accountservices.day_time_limit.setUpModel(data);
      init();
      if (callback && typeof callback === 'function') {
        callback(svs.day_time_limit.data.dayTimeLimit, null);
      }
    }, error => {
      logger.info('Error clearing daytimelimit', error);
      if (callback && typeof callback === 'function') {
        callback(error, null);
      }
    });
  }

  function close() {
    logger.info('Closing day time limit message box without user interaction');
    svs.ui.dialog.api.hideDimmer();
  }
  try {
    Backbone.history.on('route', () => {
      logger.debug('Backbone navigation. Get day time limit from backend');
      get();
    });
  } catch (e) {
    logger.debug('No backbone at this page');
  }

  function msToMinutesAndSeconds(ms) {
    const daysMs = ms % (24 * 60 * 60 * 1000);
    const hours = Math.floor(daysMs / (60 * 60 * 1000));
    const hoursMs = ms % (60 * 60 * 1000);
    const minutes = Math.floor(hoursMs / (60 * 1000));
    const minutesMs = ms % (60 * 1000);
    const seconds = (minutesMs / 1000).toFixed(0);
    return "".concat(hours, " h ").concat(minutes, " min ").concat(seconds, " sec");
  }

  function getSoonMsgRemainingTime() {
    const soonMsgRemainingTime = soonMsgTimeoutMs - (new Date().getTime() - soonMsgTimeoutStart);
    let shown;
    let msg;
    if (soonMsgRemainingTime > 0) {
      shown = false;
      msg = "Remaining time for soon end message timer: ".concat(msToMinutesAndSeconds(soonMsgRemainingTime), " (").concat(soonMsgRemainingTime, "ms)");
      logger.debug(msg);
    } else {
      shown = true;
      msg = "Soon end message already shown";
      logger.debug(msg);
    }
    return {
      shown,
      msg,
      soonMsgRemainingTime
    };
  }

  function getEndMsgRemainingTime() {
    const endMsgRemainingTime = endMsgTimeoutMs - (new Date().getTime() - endMsgTimeoutStart);
    let shown;
    let msg;
    if (endMsgRemainingTime > 0) {
      shown = false;
      msg = "Remaining time for end message timer: ".concat(msToMinutesAndSeconds(endMsgRemainingTime), " (").concat(endMsgRemainingTime, "ms)");
      logger.debug(msg);
    } else {
      shown = true;
      msg = "End message already shown";
      logger.debug(msg);
    }
    return {
      shown,
      msg,
      endMsgRemainingTime
    };
  }

  function getRemainingTimes() {
    const soonMsgShown = getSoonMsgRemainingTime().shown;
    const endMsgShown = getEndMsgRemainingTime().shown;
    let msg;
    if (soonMsgShown && endMsgShown) {
      msg = "Soon end message and end message shown";
      logger.debug(msg);
    } else if (soonMsgShown && !endMsgShown) {
      msg = "Only soon end message shown";
      logger.debug(msg);
    } else {
      msg = "None of soon end message or end message shown";
      logger.debug(msg);
    }
    return msg;
  }

  function getDayTimeLimits() {
    const info = "Day time limit is".concat(!svs.day_time_limit.data.dayTimeLimit.dayTimeLimitIsSet ? ' not' : '', " set");
    const model = "Day time limit model:\n          ".concat(JSON.stringify(svs.day_time_limit.data.dayTimeLimit, undefined, 2));
    logger.debug(info);
    logger.debug(model);
    return "".concat(info, "\n\n").concat(model);
  }
  function debugInfo() {
    if (svs.core.config.data.svsconfig.env !== 'production') {
      const infoText = "".concat(getSoonMsgRemainingTime().msg, "<br>").concat(getEndMsgRemainingTime().msg);
      let iDiv;
      if (svs.day_time_limit && svs.day_time_limit.data && svs.day_time_limit.data.dubugging) {
        if (document.getElementById('dayTimeLimitInfo')) {
          iDiv = document.getElementById('dayTimeLimitInfo');
          iDiv.style.display = 'block';
        } else {
          iDiv = document.createElement('div');
          iDiv.id = 'dayTimeLimitInfo';
          iDiv.style.height = 'auto';
          iDiv.style.zIndex = '9999';
          iDiv.style.left = '0';
          iDiv.style.padding = '0 3px';
          iDiv.style.bottom = '0';
          iDiv.style.position = 'fixed';
          iDiv.style.color = '#afafb3';
          iDiv.style.backgroundColor = 'rgba(0,0,0,0.5)';
          iDiv.style.display = 'block';
          document.getElementsByTagName('body')[0].appendChild(iDiv);
        }
        iDiv.innerHTML = infoText;
        iDiv.title = svs.accountservices.day_time_limit.debug.dayTimeLimits();
        setTimeout(svs.accountservices.day_time_limit.debug.info, 1000);
      } else if (document.getElementById('dayTimeLimitInfo')) {
        document.getElementById('dayTimeLimitInfo').style.display = 'none';
      }
    }
  }
  function activateDebugging() {
    svs.day_time_limit.data.dubugging = true;
    debugInfo();
  }
  function deActivateDebugging() {
    svs.day_time_limit.data.dubugging = false;
    debugInfo();
  }

  svs.accountservices.day_time_limit.debug = {
    remainingTimes: getRemainingTimes,
    dayTimeLimits: getDayTimeLimits,
    soonMsgRemainingTime: getSoonMsgRemainingTime,
    endMsgRemainingTime: getEndMsgRemainingTime,
    info: debugInfo,
    activate: activateDebugging,
    deActivate: deActivateDebugging
  };

  svs.accountservices.day_time_limit.test = {
    getSoonMsgTimeoutID: () => soonMsgTimeoutID,
    getEndMsgTimeoutID: () => endMsgTimeoutID,
    getLogger: () => logger
  };
  svs.accountservices.day_time_limit.start = init;
  svs.accountservices.day_time_limit.showSoonEndMessage = showSoonEndMessage;
  svs.accountservices.day_time_limit.showEndMessage = showEndMessage;
  svs.accountservices.day_time_limit.get = get;
  svs.accountservices.day_time_limit.set = set;
  svs.accountservices.day_time_limit.clear = clear;
  svs.accountservices.day_time_limit.close = close;
  svs.accountservices.day_time_limit.showErrorDialog = showErrorDialog;
})(svs);

 })(window);